/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/spinner/spinner.component.ngfactory';
import * as import2 from '../../ui-elements/spinner/spinner.component';
import * as import3 from 'ng2-translate/src/translate.pipe';
import * as import4 from 'ng2-translate/src/translate.service';
import * as import5 from '../../buttons/link/link.component.ngfactory';
import * as import6 from '../../buttons/link/link.component';
import * as import7 from '@angular/common';
import * as import8 from '../../string-utils/currency.pipe';
import * as import9 from '../../html-utils/html.pipe';
import * as import10 from '@angular/platform-browser';
import * as import11 from './order-totals-panel.component';
import * as import12 from '../../ordering-context/ordering-context.model';
import * as import13 from '../order.model';
import * as import14 from '../../orchestration/navigation.service';
const styles_OrderTotalsPanelComponent:any[] = ([] as any[]);
export const RenderType_OrderTotalsPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderTotalsPanelComponent,
  data: {}
}
);
function View_OrderTotalsPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-spinner',[[
        'class',
        'order-spinner'
      ]
    ],(null as any),(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(49152,(null as any),0,import2.SpinnerComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(null as any));
}
function View_OrderTotalsPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'order-totals-total'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'order-totals-total-description'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-totals-total-value'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'discount-label-',v.context.index,'');
    ck(v,2,0,currVal_0);
    const currVal_1:any = v.context.$implicit.name;
    ck(v,3,0,currVal_1);
    const currVal_2:any = import0.ɵinlineInterpolate(1,'discount-value-',v.context.index,'');
    ck(v,5,0,currVal_2);
    const currVal_3:any = import0.ɵunv(v,6,0,ck(v,7,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),(0 - v.context.$implicit.amount)));
    ck(v,6,0,currVal_3);
  });
}
function View_OrderTotalsPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'order-totals-total'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'order-totals-total-description'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-totals-total-value'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'surcharge-label-',v.context.index,'');
    ck(v,2,0,currVal_0);
    const currVal_1:any = v.context.$implicit.name;
    ck(v,3,0,currVal_1);
    const currVal_2:any = import0.ɵinlineInterpolate(1,'surcharge-value-',v.context.index,'');
    ck(v,5,0,currVal_2);
    const currVal_3:any = import0.ɵunv(v,6,0,ck(v,7,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),v.context.$implicit.amount));
    ck(v,6,0,currVal_3);
  });
}
function View_OrderTotalsPanelComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'order-totals-total'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-totals-total-description'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵpod(['percentValue']),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[
      [
        'class',
        'order-totals-total-value'
      ]
      ,
      [
        'id',
        'processing-fee-value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,5).transform('woa.label.order.totals.processingFee',ck(v,4,0,co.processingFee.percentValue)));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,8,0,ck(v,9,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),co.processingFee.amount));
    ck(v,8,0,currVal_1);
  });
}
function View_OrderTotalsPanelComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',[[
        'class',
        'order-totals-total-description-action'
      ]
      ],(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.editTip()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_LinkComponent_0,import5.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import6.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.tipAmount? 'woa.button.common.change': 'woa.button.common.add');
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderTotalsPanelComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'order-totals-total'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'order-totals-total-description'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.editTip()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTotalsPanelComponent_8)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[
      [
        'class',
        'order-totals-total-value'
      ]
      ,
      [
        'id',
        'tip-value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.canEditTip;
    ck(v,6,0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.label.order.totals.tip'));
    ck(v,3,0,currVal_0);
    const currVal_2:any = import0.ɵunv(v,10,0,ck(v,11,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),co.tipAmount));
    ck(v,10,0,currVal_2);
  });
}
function View_OrderTotalsPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTotalsPanelComponent_4)),
    import0.ɵdid(802816,(null as any),0,import7.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTotalsPanelComponent_5)),
    import0.ɵdid(802816,(null as any),0,import7.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTotalsPanelComponent_6)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTotalsPanelComponent_7)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.initiatedOrder.discounts;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.initiatedOrder.surcharges;
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.processingFee;
    ck(v,9,0,currVal_2);
    const currVal_3:any = ((co.recentOrder || ((co.orderingContextModel.currentStore == null)? (null as any): co.orderingContextModel.currentStore.allowTips)) && (co.showZeroTip || co.tipAmount));
    ck(v,12,0,currVal_3);
  },(null as any));
}
function View_OrderTotalsPanelComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'order-totals-total'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-totals-total-description'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[
      [
        'class',
        'order-totals-total-value'
      ]
      ,
      [
        'id',
        'tax-value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.label.order.totals.tax'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,7,0,ck(v,8,0,import0.ɵnov((<any>(<any>v.parent).parent),0),co.taxAmount));
    ck(v,7,0,currVal_1);
  });
}
function View_OrderTotalsPanelComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'order-totals-total saving'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'order-totals-total-description'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[
      [
        'class',
        'order-totals-total-value'
      ]
      ,
      [
        'id',
        'saving-value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.label.order.totals.saving'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,7,0,ck(v,8,0,import0.ɵnov((<any>(<any>v.parent).parent),0),co.orderSaving));
    ck(v,7,0,currVal_1);
  });
}
function View_OrderTotalsPanelComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'order-totals-total'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-totals-total-description'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpod(['points']),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,2,0,ck(v,5,0,import0.ɵnov((<any>(<any>v.parent).parent),1),import0.ɵunv(v,2,0,import0.ɵnov(v,4).transform(co.pointsLabel,ck(v,3,0,co.initiatedOrder.points)))));
    ck(v,2,0,currVal_0);
  });
}
function View_OrderTotalsPanelComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'order-totals-total'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-totals-total-description'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpod(['points']),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,2,0,ck(v,5,0,import0.ɵnov((<any>(<any>v.parent).parent),1),import0.ɵunv(v,2,0,import0.ɵnov(v,4).transform('woa.label.order.totals.bonusPoints',ck(v,3,0,co.initiatedOrder.bonusPoints)))));
    ck(v,2,0,currVal_0);
  });
}
function View_OrderTotalsPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),28,'div',[[
        'class',
        'order-totals'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTotalsPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'order-totals-total final'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'order-totals-total-description'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpod(['items']),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[
      [
        'class',
        'order-totals-total-value'
      ]
      ,
      [
        'id',
        'total-payment-value'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTotalsPanelComponent_9)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTotalsPanelComponent_10)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTotalsPanelComponent_11)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderTotalsPanelComponent_12)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = !co.totalOnly;
    ck(v,3,0,currVal_0);
    const currVal_3:any = co.taxAmount;
    ck(v,18,0,currVal_3);
    const currVal_4:any = ((co.showSavings && !co.totalOnly) && (co.orderSaving > 0));
    ck(v,21,0,currVal_4);
    const currVal_5:any = co.canShowPoints;
    ck(v,24,0,currVal_5);
    const currVal_6:any = (co.canShowPoints && co.initiatedOrder.bonusPoints);
    ck(v,27,0,currVal_6);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = import0.ɵunv(v,8,0,import0.ɵnov(v,10).transform(co.totalLabel,ck(v,9,0,co.totalItems)));
    ck(v,8,0,currVal_1);
    const currVal_2:any = import0.ɵunv(v,13,0,ck(v,14,0,import0.ɵnov((<any>v.parent),0),co.totalPayment,'AU$'));
    ck(v,13,0,currVal_2);
  });
}
export function View_OrderTotalsPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import8.CurrencyPipe,([] as any[])),
    import0.ɵpid(0,import9.HtmlPipe,[import10.DomSanitizer]),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderTotalsPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import7.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderTotalsPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import7.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import11.OrderTotalsPanelComponent = v.component;
    const currVal_0:boolean = (!co.recentOrder && (import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.INITIATING));
    ck(v,3,0,currVal_0);
    const currVal_1:any = ((co.recentOrder || (import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.INITIATED)) && co.totalItems);
    ck(v,7,0,currVal_1);
  },(null as any));
}
function View_OrderTotalsPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-totals-panel',([] as any[]),(null as any),(null as any),(null as any),View_OrderTotalsPanelComponent_0,RenderType_OrderTotalsPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import11.OrderTotalsPanelComponent,[
      import12.OrderingContextModel,
      import13.OrderModel,
      import14.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const OrderTotalsPanelComponentNgFactory:import0.ComponentFactory<import11.OrderTotalsPanelComponent> = import0.ɵccf('woa-order-totals-panel',import11.OrderTotalsPanelComponent,View_OrderTotalsPanelComponent_Host_0,{
  recentOrder: 'recentOrder',
  totalOnly: 'totalOnly',
  showZeroTip: 'showZeroTip',
  showSavings: 'showSavings',
  showPoints: 'showPoints',
  canEditTip: 'canEditTip'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/order/order-totals-panel/order-totals-panel.component.ngfactory.ts